import { render, staticRenderFns } from "./DomainSslIframe.vue?vue&type=template&id=460c30e0&"
import script from "./DomainSslIframe.vue?vue&type=script&lang=ts&"
export * from "./DomainSslIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports